import { useCallback, useState } from 'react';
import apiRequest from './apiRequest';

/**
 * @param {string} [method]
 * @param {string} url
 * @return {{sendApiRequest: function(options: {data: any?, validateResponse: function(response: Object)?, onSuccess: function(response: Object, time: number)?, onError: function(error: Error, time: number)})?, processing: boolean, error: Error|null}}
 */
const useApiRequest = ({ method = 'post', url }) => {
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);

  const sendApiRequest = useCallback(({ data, validateResponse, onSuccess, onError }) => {
    const timeStart = Date.now();

    setProcessing(true);

    apiRequest({ method, url, data })
      .then((response) => {
        validateResponse?.(response);

        const time = Math.ceil((Date.now() - timeStart) / 1000);

        setError(null);
        onSuccess?.(response, time);
      })
      .catch((error) => {
        const time = Math.ceil((Date.now() - timeStart) / 1000);

        console.error(`${url} error`, error);

        setError(error);
        onError?.(error, time);
      })
      .finally(() => {
        setProcessing(false);
      });
  }, [method, url]);

  return {
    sendApiRequest,
    processing,
    error,
  };
};

export default useApiRequest;
